import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace InvestigativeSitesFields {
  export enum CommonField {
    ExpireNotificationPeriod = 'InvestigativeSites.ExpireNotificationPeriod',
    ExpirationSubscribedUsers = 'InvestigativeSites.ExpirationSubscribedUsers',
    ExpirationSubscribedGroups = 'InvestigativeSites.ExpirationSubscribedGroups',
    ActivationSubscribedUsers = 'InvestigativeSites.ActivationSubscribedUsers',
    DraftInvSitesEmailRecipientsUsers = 'InvestigativeSites.DraftEmailRecipientsUsers',
    DraftInvSitesEmailRecipientsGroups = 'InvestigativeSites.DraftEmailRecipientsGroups',
    UploadDocumentsOnlyOnTheETMF = 'IrbIntegration.UploadDocumentsOnlyOnTheETMF',
    UploadDocumentsAsFinal = 'IrbIntegration.UploadDocumentsAsFinal',
    CompleteAmendmentSubscribedUsers = 'Amendment.CompleteAmendmentSubscribedUsers',
    SiteActivationTitle = 'InvestigativeSites.SiteActivationTitle',
    ActivationSubscribedContactTypes = 'InvestigativeSites.ActivationSubscribedContacts',
    CompleteAmendmentSubscribedContactTypes = 'Amendment.CompleteAmendmentSubscribedContacts',
    RootFolderName = 'InvestigativeSites.RootFolderName',
    SetupIndexOnSiteCreation = 'InvestigativeSites.SetupIndexOnSiteCreation',
    DefaultFolderNamePattern = 'InvestigativeSites.FolderNamePattern',
    DefaultSortOrder = 'InvestigativeSites.SortOrder',
    EnableAccessRights = 'InvestigativeSites.SetDefAccForISF',
    DefaultAccessRightsValue = 'InvestigativeSites.DefISFAccessValue',
    DefAccessSubscribedUsers = 'InvestigativeSites.DefAccessSubscribedUsers',
    DefAccessSubscribedGroups = 'InvestigativeSites.DefAccessSubscribedGroups',
    DefaultReadersGroups = 'InvestigativeSites.DefaultISReaderGroups',
    DefaultEditorsGroups = 'InvestigativeSites.DefaultISEditorGroups',
    StartUpProcessingTime = 'InvestigativeSites.StartUpProcessingTime',
    ActivateWithoutPublishingDocuments = 'InvestigativeSites.ActivateWithoutPublishingDocs',
    BypassWorkflowOnSsuPublishedDocuments = 'InvestigativeSites.ByePassWorkflowOnSsuPubDocs',
    UseTwoPassWorkflowForNonEssentialDocuments = 'InvestigativeSites.UseTwoPassWorkflowForNonEDocs',
    NoDocumentsForActivatedSites = 'InvestigativeSites.NoDocumentsForActivatedSites',
    AllowPaperDocuments = 'InvestigativeSites.AllowPaperDocuments',
    SetupIndexAfterSiteActivation = 'InvestigativeSites.SetupIndexAfterSiteActivation',
    AllowAddUsersAsContacts = 'InvestigativeSites.AllowAddUsersAsContacts',
    ProtectedTemplateFolderId = 'InvestigativeSites.ProtectedTemplateFolderId',
    StagingTemplateFolderId = 'InvestigativeSites.StagingTemplateFolderId',
    PublishSelectedDocuments = 'InvestigativeSites.PublishSelectedDocuments',
    SSUDocumentApprovalWorkflow = 'InvestigativeSites.SSUDocumentApprovalWorkflow',
    DisabledSiteStatusTypes = 'InvestigativeSites.DisabledSiteStatusTypes',
    DisabledIRBStatusTypes = 'InvestigativeSites.DisabledIRBStatusTypes',
    EnableSponsorReview = 'InvestigativeSites.EnableSponsorReview',
  }

  export enum RegpackDeliveryField {
    SendAs = 'RegpackDelivery.SendAs',
    RegPackName = 'RegpackDelivery.RegPackName',
  }
}

class CommonConfig extends SettingsSubModule {
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.ExpireNotificationPeriod, 10)
  expireNotificationPeriod: SettingValue<number>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.ExpirationSubscribedUsers, '')
  expirationSubscribedUsers: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.ExpirationSubscribedGroups, '')
  expirationSubscribedGroups: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.ActivationSubscribedUsers, '')
  activationSubscribedUsers: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.DraftInvSitesEmailRecipientsUsers, '')
  draftInvSitesEmailRecipientsUsers: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.DraftInvSitesEmailRecipientsGroups, '')
  draftInvSitesEmailRecipientsGroups: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.UploadDocumentsOnlyOnTheETMF, false)
  uploadDocumentsOnlyOnTheETMF: SettingValue<boolean>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.UploadDocumentsAsFinal, false)
  uploadDocumentsAsFinal: SettingValue<boolean>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.CompleteAmendmentSubscribedUsers, '')
  completeAmendmentSubscribedUsers: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.SiteActivationTitle, 'Site Activation')
  siteActivationTitle: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.ActivationSubscribedContactTypes, '')
  activationSubscribedContactTypes: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.CompleteAmendmentSubscribedContactTypes, '')
  completeAmendmentSubscribedContactTypes: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.RootFolderName, 'Site Management')
  rootFolderName: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.SetupIndexOnSiteCreation, false)
  setupIndexOnSiteCreation: SettingValue<boolean>;
  @SettingsSubModule.value(
    InvestigativeSitesFields.CommonField.DefaultFolderNamePattern,
    'Site ##SiteNumber## ##PrincipalInvestigator## Site Management',
  )
  defaultFolderNamePattern: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.DefaultSortOrder, 5)
  defaultSortOrder: SettingValue<number>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.EnableAccessRights, false)
  enableAccessRights: SettingValue<boolean>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.DefaultAccessRightsValue, 64)
  defaultAccessRightsValue: SettingValue<number>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.DefAccessSubscribedUsers, '')
  defAccessSubscribedUsers: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.DefAccessSubscribedGroups, '')
  defAccessSubscribedGroups: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.DefaultReadersGroups, '')
  defaultReadersGroups: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.DefaultEditorsGroups, '')
  defaultEditorsGroups: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.StartUpProcessingTime, 0)
  startUpProcessingTime: SettingValue<number>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.ActivateWithoutPublishingDocuments, false)
  activateWithoutPublishingDocuments: SettingValue<boolean>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.BypassWorkflowOnSsuPublishedDocuments, false)
  bypassWorkflowOnSsuPublishedDocuments: SettingValue<boolean>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.UseTwoPassWorkflowForNonEssentialDocuments, false)
  useTwoPassWorkflowForNonEssentialDocuments: SettingValue<boolean>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.NoDocumentsForActivatedSites, false)
  noDocumentsForActivatedSites: SettingValue<boolean>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.AllowPaperDocuments, false)
  allowPaperDocuments: SettingValue<boolean>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.SetupIndexAfterSiteActivation, false)
  setupIndexAfterSiteActivation: SettingValue<boolean>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.AllowAddUsersAsContacts, false)
  allowAddUsersAsContacts: SettingValue<boolean>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.ProtectedTemplateFolderId, 0)
  protectedTemplateFolderId: SettingValue<number>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.StagingTemplateFolderId, 0)
  stagingTemplateFolderId: SettingValue<number>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.PublishSelectedDocuments, true)
  publishSelectedDocuments: SettingValue<boolean>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.SSUDocumentApprovalWorkflow, 1)
  SSUDocumentApprovalWorkflow: SettingValue<number>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.DisabledSiteStatusTypes, '')
  disabledSiteStatusTypes: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.DisabledIRBStatusTypes, '')
  disabledIRBStatusTypes: SettingValue<string>;
  @SettingsSubModule.value(InvestigativeSitesFields.CommonField.EnableSponsorReview, false)
  enableSponsorReview: SettingValue<boolean>;
}

class RegpackDeliveryConfig extends SettingsSubModule {
  @SettingsSubModule.value(InvestigativeSitesFields.RegpackDeliveryField.SendAs, 0) sendAs: SettingValue<number>;
  @SettingsSubModule.value(InvestigativeSitesFields.RegpackDeliveryField.RegPackName, 'Reg. Packet')
  regPackName: SettingValue<string>;
}

export class InvestigativeSitesModule extends SettingsModule {
  @SettingsModule.value(CommonConfig) common: CommonConfig;
  @SettingsModule.value(RegpackDeliveryConfig) regpackDelivery: RegpackDeliveryConfig;
}
